var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElement3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/element-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "element-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 7.09999V3.31666C18.3333 2.14166 17.8 1.66666 16.475 1.66666H13.1083C11.7833 1.66666 11.25 2.14166 11.25 3.31666V7.09166C11.25 8.27499 11.7833 8.74166 13.1083 8.74166H16.475C17.8 8.74999 18.3333 8.27499 18.3333 7.09999Z",
    fill: "#26252C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3333 16.475V13.1083C18.3333 11.7833 17.8 11.25 16.475 11.25H13.1083C11.7833 11.25 11.25 11.7833 11.25 13.1083V16.475C11.25 17.8 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8 18.3333 16.475Z",
    fill: "#26252C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.75033 7.09999V3.31666C8.75033 2.14166 8.21699 1.66666 6.89199 1.66666H3.52533C2.20033 1.66666 1.66699 2.14166 1.66699 3.31666V7.09166C1.66699 8.27499 2.20033 8.74166 3.52533 8.74166H6.89199C8.21699 8.74999 8.75033 8.27499 8.75033 7.09999Z",
    fill: "#26252C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.75033 16.475V13.1083C8.75033 11.7833 8.21699 11.25 6.89199 11.25H3.52533C2.20033 11.25 1.66699 11.7833 1.66699 13.1083V16.475C1.66699 17.8 2.20033 18.3333 3.52533 18.3333H6.89199C8.21699 18.3333 8.75033 17.8 8.75033 16.475Z",
    fill: "#26252C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement3);
export default __webpack_public_path__ + "static/media/element-3.1db137e7bd06e5d1f0b6e51352985010.svg";
export { ForwardRef as ReactComponent };